import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import CalendarGrid from "./CalendarGrid";
import { useLanguage } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Availability = () => {
  const { t } = useLanguage();
  const [blocked, setBlocked] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/availability`)
      .then((r) => setBlocked(r.data.blocked))
      .catch(() => {});
  }, []);

  return (
    <section id="disponibilita" data-testid="availability-section" className="py-20 lg:py-32 px-6 sm:px-12 lg:px-20 bg-[#EFEAE1]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl mb-12"
        >
          <p className="text-xs uppercase tracking-[0.25em] font-mono-alt font-semibold text-[#C86D51] mb-4">{t.availability.eyebrow}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0D253A]">{t.availability.title}</h2>
          <p className="mt-5 text-base sm:text-lg text-[#333D47]">{t.availability.text}</p>
          <div data-testid="availability-legend" className="mt-6 flex items-center gap-6 text-xs text-[#5C6773]">
            <span className="flex items-center gap-2">
              <span className="w-3.5 h-3.5 rounded-full bg-white border border-[#0D253A]/25" />
              {t.availability.free}
            </span>
            <span className="flex items-center gap-2">
              <span className="w-3.5 h-3.5 rounded-full bg-[#C86D51]/25 border border-[#C86D51]/40" />
              {t.availability.busy}
            </span>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          <CalendarGrid blocked={blocked} months={2} testidPrefix="availability" />
        </motion.div>
      </div>
    </section>
  );
};

export default Availability;
